<template>
  <ul>
    <li
      v-for="yacht in fleetData"
      :id="yacht.RaceEntryId"
      :key="yacht.RaceEntryId"
      role="button"
      class="ripple"
      @click="onRowClicked(yacht.RaceEntryId)"
    >
      <div
        :class="getYachtStatusClasses(yacht)"
        class="yacht-status-icon"
      />
      <div class="yacht-name-wrapper">
        <div class="yacht-name">
          {{ yacht.Name }}
        </div>
        <div class="yacht-divisions">
          <div
            v-for="cat in yacht.Categories"
            :key="`${yacht.RaceEntryId}_${cat.CategoryId}`"
            class="category"
          >
            <div
              :class="getDivisionClassCode(cat.Name)"
              :aria-label="`${cat.Name}`"
            >
              {{ cat.Name | shortCatName }}
            </div>
          </div>
        </div>
      </div>
      <button
        :aria-label="`Save '${yacht.Name}' as favourite`"
        class="favourite-icon"
        @click.stop.prevent="favouriteOnClick(yacht)"
      >
        <font-awesome-icon
          v-if="favourites.includes(yacht.RaceEntryId)"
          :icon="['fas', 'heart']"
          aria-hidden="true"
        />
        <font-awesome-icon
          v-else
          :icon="['far', 'heart']"
          aria-hidden="true"
        />
      </button>
    </li>
  </ul>
</template>

<script>
import { library } from '@fortawesome/fontawesome-svg-core'
import { faHeart as fasHeart } from '@fortawesome/free-solid-svg-icons'
import { faHeart as farHeart } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(fasHeart, farHeart)

import { EventBus } from '../../eventBus'
export default {
  components: {
    FontAwesomeIcon
  },
  filters: {
    shortCatName: function (value) {
      switch (value.toLowerCase()) {
        case ('line honours'):
          return 'L. H.'
          break
        case ('irc'):
          return 'IRC'
          break
        case ('orci'):
          return 'ORCi'
          break
        case ('phs'):
          return 'PHS'
          break
        case ('corinthian'):
          return 'Cor.'
          break
        case ('corinthian - irc'):
          return 'C. IRC'
          break
        case ('corinthian - phs'):
          return 'C. PHS'
          break
        case ('sydney 38'):
          return 'Syd. 38'
          break
        case ('veterans'):
          return 'Vet.'
          break
        case ('grand veterans'):
          return 'G. Vet.'
          break
        default:
          return value
      }
    }
  },
  props: {
    fleetData: {
      type: Array,
      default: () => []
    },
    favourites: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    onRowClicked(raceEntryId) {
      setTimeout(() => {
        EventBus.$emit('yachtRowClicked', raceEntryId)
      }, 500)
    },
    getYachtStatusClasses(yacht) {
      const classNames = []

      if (yacht.IsLineHonourRecord)
        classNames.push('is-record-holder')

      if (yacht.Position) {
        if (yacht.Position.IsRetired)
          classNames.push('is-retired')
        if (yacht.Position.IsRacing)
          classNames.push('is-racing')
        if (yacht.Position.IsFinished)
          classNames.push('is-finished')
      }

      if (yacht.Categories) {
        if (yacht.Categories.findIndex(cat => cat.DivPlace === 1) > -1)
          classNames.push('is-div-leader')
        if (yacht.Categories.findIndex(cat => cat.Name === 'Line Honours' && cat.DivPlace === 1) > -1)
          classNames.push('is-race-leader')
      }

      if (classNames.length === 0)
        classNames.push('is-unknown')

      return classNames
    },
    getDivisionClassCode(catName) {
      const catNameLower = catName.toLowerCase()
      if (catNameLower.includes('line honours')) return 'div-lh'
      if (catNameLower.includes('irc')) return 'div-irc'
      if (catNameLower.includes('orci')) return 'div-orci'
      if (catNameLower.includes('phs')) return 'div-phs'
      if (catNameLower.includes('corinthian - irc')) return 'div-circ'
      if (catNameLower.includes('corinthian - phs')) return 'div-cphs'
      if (catNameLower.includes('sydney 38')) return 'div-syd38'
      return 'div-other'
    },
    favouriteOnClick(yacht) {
      this.$emit('favourite-clicked', yacht)
    }
  }
}
</script>

<style lang="less" scoped>
/* reset defaults */
ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

@active-color: #b4bfce;
@focus-color: #e3e6ea;

ul {
  background-color: #ebecf0;
  padding: 10px;

  li {
    background-color: #fff;
    border-radius: 3px;
    box-shadow: 0 1px 0 rgba(9, 30, 66, 0.25);
    cursor: pointer;
    display: block;
    margin-bottom: 8px;
    // max-width: 300px;
    min-height: 20px;
    position: relative;
    text-decoration: none;
    z-index: 0;

    &.ripple {
      background-position: center;
      transition: background 0.5s;
      cursor: pointer;
      &:hover {
        background: @focus-color
          radial-gradient(circle, transparent 1%, @focus-color 1%) center/15000%;
      }
      &:active {
        background-color: @active-color;
        background-size: 100%;
        transition: background 0s;
      }
    }
    padding: 10px 12px 10px 12px;
    height: 3rem;
    display: flex;
    .yacht-name-wrapper {
      width: 67%;
      flex-shrink: 1;
      flex-basis: 80%;
    }
    .yacht-name {
      font-family: Din_Med, Arial;
      font-size: 1rem;
      margin-bottom: 0.3rem;
      height: 1.2rem;
      line-height: 1.2rem;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .yacht-divisions {
      display: flex;
      overflow-x: auto;
      overflow-y: hidden;
      -ms-overflow-style: none; /* ie 11 */
    }
    button.favourite-icon {
      width: 48px;
      height: 48px;
      font-size: 1.25rem;
      color: #263b59;
      -webkit-appearance: none;
      -moz-appearance: none;
      appearance: none;
      background-color: transparent;
      border: unset;
      border: none;
    }
  }
}
</style>


<style lang="less" scoped>
.yacht-status-icon {
  background-size: contain;
  background-repeat: no-repeat;
  width: 1rem;
  height: 2rem;
  margin-right: 0.5rem;
  flex: 0 0 1rem;
}

.is-racing {
  background-image: url(../../assets/yacht-flag-blue.png);
}

.is-div-leader {
  background-image: url(../../assets/yacht-flag-green.png);
}

.is-race-leader {
  background-image: url(../../assets/yacht-flag-red.png);
}

.is-retired {
  background-image: url(../../assets/yacht-flag-grey.png);
}

.is-record-holder {
  background-image: url(../../assets/yacht-flag-orange.png);
}
</style>

<style lang="less" scoped>
[class^="div-"] {
  background-color: lightblue;
  border-radius: 10px;
  height: 20px;
  margin-right: 4px;
  font-size: 0.75rem;
  padding: 0 5px;
  box-sizing: border-box;
  vertical-align: middle;
  line-height: 1.25rem;
  font-family: Din_Med, Arial;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  .is-selected & {
    background-color: white;
    color: #1787cb;
  }
}

.div-lh {
  background-color: rgba(54, 192, 0, 0.1);
  color: rgba(54, 192, 0, 1);
}

.div-irc {
  background-color: rgba(255, 0, 0, 0.1);
  color: rgba(255, 0, 0, 1);
}

.div-circ {
  background-color: rgba(255, 0, 0, 0.1);
  color: rgba(255, 0, 0, 1);
}

.div-orci {
  background-color: rgba(255, 166, 0, 0.1);
  color: rgba(255, 166, 0, 1);
}

.div-phs {
  background-color: rgba(0, 60, 255, 0.1);
  color: rgba(0, 60, 255, 1);
}

.div-cphs {
  background-color: rgba(0, 60, 255, 0.1);
  color: rgba(0, 60, 255, 1);
}

.div-syd38 {
  background-color: rgba(140, 0, 255, 0.1);
  color: rgb(140, 0, 255);
}

.div-other {
  background-color: rgba(121, 121, 121, 0.1);
  color: rgb(121, 121, 121);
}
</style>